import React from 'react';
import Icon from '../../../components/AppIcon';

const TrendingKeywords = ({ keywords }) => {
  return (
    <div className="bg-card rounded-lg p-6 border border-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Trending Keywords</h3>
        <Icon name="TrendingUp" size={20} className="text-success" />
      </div>
      <div className="space-y-4">
        {keywords?.map((keyword, index) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-sm font-medium text-foreground">
                  {keyword?.term}
                </span>
                {keyword?.trending && (
                  <span className="px-2 py-0.5 bg-success/10 text-success text-xs font-medium rounded-full">
                    Hot
                  </span>
                )}
              </div>
              <div className="flex items-center gap-4 text-xs text-muted-foreground">
                <span>Volume: {keyword?.searchVolume}</span>
                <span className="flex items-center gap-1">
                  <Icon 
                    name={keyword?.trend === 'up' ? 'ArrowUp' : 'ArrowDown'} 
                    size={12} 
                    className={keyword?.trend === 'up' ? 'text-success' : 'text-error'}
                  />
                  {keyword?.change}
                </span>
              </div>
            </div>
            <div className="text-right">
              <div className="text-sm font-semibold text-foreground">
                {keyword?.pins}
              </div>
              <div className="text-xs text-muted-foreground">pins</div>
            </div>
          </div>
        ))}
      </div>
      <button className="w-full mt-4 py-2 text-sm text-primary hover:bg-primary/5 rounded-lg transition-colors font-medium">
        View All Keywords
      </button>
    </div>
  );
};

export default TrendingKeywords;